import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ApiDataType, EnvironmentInterface } from '../../types';

@Injectable({
    providedIn: 'root'
})
export class RegisterService {
    /* eslint-disable */
    apiUrl: string | undefined;

    constructor(
        private http: HttpClient,
        @Inject('environment') environment: EnvironmentInterface
    ) {
        this.setApiUrl(environment.apiUrl);
    }

    setApiUrl(url: string) {
        this.apiUrl = url;
    }

    registerUser(data: any): Observable<ApiDataType> {
        return this.http.post<ApiDataType>(`${this.apiUrl}/register`, data);
    }

    getOtpCode(phone: string): Observable<ApiDataType> {
        return this.http.post<ApiDataType>(`${this.apiUrl}/phone-verification/otp`, { phone });
    }

    verifyOtpCode(code: string): Observable<ApiDataType> {
        return this.http.post<ApiDataType>(`${this.apiUrl}/phone-verification/verify`, { code });
    }

    resendOtpCode(): Observable<ApiDataType> {
        return this.http.post<ApiDataType>(`${this.apiUrl}/phone-verification/resend`, {});
    }
}
